import {
  GET_TRANSFERDETAIL,
  GET_TRANSFERDETAIL_SUCCESS,
  GET_TRANSFERDETAIL_FAIL,
  DELETE_TRANSFERDETAIL,
  DELETE_TRANSFERDETAIL_SUCCESS,
  DELETE_TRANSFERDETAIL_FAIL,
  UPDATE_TRANSFERDETAIL,
  UPDATE_TRANSFERDETAIL_SUCCESS,
  UPDATE_TRANSFERDETAIL_FAIL,
  ADD_NEW_TRANSFERDETAIL,
  ADD_TRANSFERDETAIL_SUCCESS,
  ADD_TRANSFERDETAIL_FAIL,
  TRANSFERDETAIL_LOADING,
  TRANSFERDETAIL_RESET,
} from "./actionType";

export const resetTransferDetailState = (actionType) => ({
  type: TRANSFERDETAIL_RESET,
  payload: { actionType },
});

export const getTransferDetailSuccess = (actionType, data) => ({
  type: GET_TRANSFERDETAIL_SUCCESS,
  payload: { actionType, data },
});

export const getTransferDetailFail = (actionType, error) => ({
  type: GET_TRANSFERDETAIL_FAIL,
  payload: { actionType, error },
});

export const getTransferDetail = data => ({
  type: GET_TRANSFERDETAIL,
  payload: data,
});

export const getTransferDetailLoading = () => ({
  type: TRANSFERDETAIL_LOADING
});

export const deleteTransferDetail = data => ({
  type: DELETE_TRANSFERDETAIL,
  payload: data,
});

export const deleteTransferDetailSuccess = data => ({
  type: DELETE_TRANSFERDETAIL_SUCCESS,
  payload: data,
});

export const deleteTransferDetailFail = error => ({
  type: DELETE_TRANSFERDETAIL_FAIL,
  payload: error,
});

export const updateTransferDetail = data => ({
  type: UPDATE_TRANSFERDETAIL,
  payload: data,
});

export const updateTransferDetailFail = error => ({
  type: UPDATE_TRANSFERDETAIL_FAIL,
  payload: error,
});

export const updateTransferDetailSuccess = data => ({
  type: UPDATE_TRANSFERDETAIL_SUCCESS,
  payload: data,
});

export const addNewTransferDetail = data => ({
  type: ADD_NEW_TRANSFERDETAIL,
  payload: data,
});

export const addTransferDetailSuccess = data => ({
  type: ADD_TRANSFERDETAIL_SUCCESS,
  payload: data,
});

export const addTransferDetailFail = error => ({
  type: ADD_TRANSFERDETAIL_FAIL,
  payload: error,
});